import { baseApi } from "./baseApi";
const REAL_TIME_TRACKING_BASE_URL = "/realtime-tracking";

export const realTimeTrackingApi = baseApi.injectEndpoints({
  tagTypes: ["RealTimeTracking"],

  endpoints: (build) => ({
    addRealTimeTracking: build.mutation({
      query: (body) => ({
        url: REAL_TIME_TRACKING_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "RealTimeTracking", id: "LIST" }],
    }),
    listRealTimeTracking: build.query({
      query: (params) => ({
        url: REAL_TIME_TRACKING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "RealTimeTracking",
              id: _id,
            })),
            { type: "RealTimeTracking", id: "LIST" },
          ]
          : [{ type: "RealTimeTracking", id: "LIST" }],
    }),
    getDDLRealTimeTrackingList: build.query({
      query: (params) => ({
        url: `${REAL_TIME_TRACKING_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ id }) => ({
              type: "RealTimeTracking",
              id,
            })),
            { type: "RealTimeTracking", id: "DDL" },
          ]
          : [{ type: "RealTimeTracking", id: "DDL" }],
    }),
    getRealTimeTrackingDetail: build.query({
      query: (trackingId) => `${REAL_TIME_TRACKING_BASE_URL}/${trackingId}`,
      providesTags: (result, error, { _id }) => [
        { type: "RealTimeTracking", id: _id },
        { type: "RealTimeTracking", id: "LIST" },
      ],
    }),
    updateRealTimeTracking: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${REAL_TIME_TRACKING_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "RealTimeTracking", id },
        { type: "RealTimeTracking", id: "LIST" },
      ],
    }),

    listVehicleLocationByVehicleId: build.query({
      query: ({ vehicleId, ...params }) => ({
        url: `${REAL_TIME_TRACKING_BASE_URL}/vehicle/${vehicleId}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "RealTimeTracking", id: _id })),
            { type: "RealTimeTracking", id: "LIST" },
          ]
          : [{ type: "RealTimeTracking", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListRealTimeTrackingQuery,
  useLazyListRealTimeTrackingQuery,
  useAddRealTimeTrackingMutation,
  useLazyGetDDLRealTimeTrackingListQuery,
  useGetRealTimeTrackingDetailQuery,
  useUpdateRealTimeTrackingMutation,

  useListVehicleLocationByVehicleIdQuery,
} = realTimeTrackingApi;
